import { AppUserInformation } from "@/models/app/user-information";
import { AppCoupon } from "@/models/app/coupon";
import { AppOrder } from "@/models/app/order";

export class AppUser {
  constructor(
    public id: number | null = null,
    public facebook_id: string | null = null,
    public google_id: string | null = null,
    public name: string = "",
    public email: string = "",
    public password: string = "",
    public password_confirmation: string = "",
    public role: string = "",
    public locale: string = "en",
    public is_consent: boolean = false,
    public is_verified: boolean = false,
    public revoked_at: string | null = null,
    public created_at: string = "",
    public updated_at: string = "",
    public user_information: AppUserInformation | null = null,
    public coupons: AppCoupon[] = [],
    public orders: AppOrder[] = []
  ) {}
}
